module.exports = __webpack_public_path__ + "img/1F1FC-1F1F8.bc087654.svg";